/**
 * Copyright 2016-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {
    INDICATORS_LOADED,
    SELECT_INDICATOR,
    SET_INDICATORS,
    ADD_FOR_INDICATORS,
    RESET_FOR_INDICATORS,
    REMOVE_FOR_INDICATORS,
    ADD_ADDINDICATORS,
    REMOVE_ADDINDICATORS,
    RESET_ADDINDICATORS,
    SELECT_COMPAREINDICATOR,
    RESET_COMPAREINDICATOR,

} from '../actions/indicators';

const defaultState = {
    indicators: [],
    selectedIndicator: null,
    selectedObjectType: null,
    selectedDate: null,
    selectedObjects: [],
    additionalIndicators: [],
    compareIndicator: null,
};

export default function indicators(state = defaultState, action) {
    switch (action.type) {
        case SELECT_COMPAREINDICATOR: {
            return {...state, compareIndicator: action.indicator};
        }
        case RESET_COMPAREINDICATOR: {
            return {...state, compareIndicator: null};
        }
        case RESET_ADDINDICATORS: {
            return {...state, additionalIndicators: []};
        }
        case REMOVE_ADDINDICATORS: {
            const inds = [];
            state.additionalIndicators.forEach(o => {
                if (o.indicator.id != action.indicator.indicator.id || o.time != action.indicator.time) {
                    inds.push(o);
                }
            });
            return {...state, additionalIndicators: inds};
        }
        case ADD_ADDINDICATORS: {
            const inds = [...state.additionalIndicators];
            inds.push(action.indicator);
            return {...state, additionalIndicators: inds};
        }
        case RESET_FOR_INDICATORS: {
            return {...state, selectedObjects: []};
        }
        case REMOVE_FOR_INDICATORS: {
            const objects = [];
            state.selectedObjects.forEach(o => {
                if (o.properties.id != action.object.properties.id) {
                    objects.push(o);
                }
            });
            return {...state, selectedObjects: objects};
        }
        case ADD_FOR_INDICATORS: {
            const objects = [];
            let add = true;
            state.selectedObjects.forEach(o => {
                objects.push(o);
                if (o.properties.id == action.object.properties.id) {
                    add = false;
                }
            })
            if (add) {
                objects.push(action.object);
            }
            return {...state, selectedObjects: objects};
        }
        case INDICATORS_LOADED: {
            return {...state, indicators: action.indicators};
        }
        case SELECT_INDICATOR: {
            return {
                ...state,
                selectedIndicator: action.indicator,
                selectedObjectType: action.objectType,
                selectedDate: action.date
            };
        }
        case SET_INDICATORS: {
            return {...state, indicators: action.indicators};
        }
        default:
            return state;
    }
}
